import styled from 'styled-components';

import { LinkBox } from 'atoms/navigation/Box';
import { laptopAndAbove } from 'style/mediaQuery';

export const Line = styled(LinkBox)`
  display: grid;
  align-items: center;
  grid-template-columns: var(--columns);
  grid-template-areas: var(--areas);
  column-gap: var(--unit);
  row-gap: var(--half-unit);
  overflow: auto;
  padding: var(--double-unit) 0;
  border-bottom: 1px solid var(--c-nd-100);

  @media ${laptopAndAbove} {
    overflow: visible;
    &:hover,
    &:focus-within {
      border-color: transparent;
      &::before {
        position: absolute;
        inset: 0 calc(var(--unit) * -1);
        border-radius: var(--double-unit);
        background: var(--c-nd-100);
        content: '';
        z-index: -1;
      }
    }
  }
`;
